// extracted by mini-css-extract-plugin
export default {"tableContainer":"HavenExtraTable_tableContainer__Q97T+","gradeTable":"HavenExtraTable_gradeTable__K0jgx"};